import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { ADMIN_PREFIX } from '../config';
import { IRecordMap, IAllRecordMap } from '../../model/api-modules';

// 记录
export const getDictionaryHistory = (key: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/dictionary/config-history/${key}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IRecordMap>(response, 'data');
      return res;
    } catch (error) {
      console.error(error);
    }
  });

// 所有记录
export const getDictionaryConfigHistory = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/dictionary/config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IAllRecordMap>(response, 'data');
      return res;
    } catch (error) {
      console.error(error);
    }
  });
